export const languages = [
  'English',
  'Malay',
  'Mandarin',
  'Cantonese',
  'Japanese',
  'Korean',
  'Arabic',
  'French',
  'Tamil'
]
